import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import { getDeviationTitle, styleFromWidthHeight } from '../../_helpers';
import ExcerptRenderer from '../../../TextRenderer/ExcerptRenderer';
import s from './Literature.scss';
const typeMap = {
    ANTFART: 'antfart',
    NANO: 'nano',
    SMALL: 'small',
    MEDIUM: 'medium',
    BIG: 'big'
};
// not sure about the correct approach, I used the comparison with the area, as there were no breakpoints for height and width
export const typeSizeMap = {
    ANTFART: 66,
    NANO: 150,
    SMALL: 214,
    MEDIUM: 250,
    BIG: 280
};
function getTypeBasedOnSize(size) {
    if (size <= typeSizeMap.ANTFART) {
        return typeMap.ANTFART;
    }
    if (size <= typeSizeMap.NANO) {
        return typeMap.NANO;
    }
    if (size <= typeSizeMap.SMALL) {
        return typeMap.SMALL;
    }
    if (size > typeSizeMap.BIG) {
        return typeMap.BIG;
    }
    return typeMap.MEDIUM;
}
const LiteratureDumbView = ({ deviation , width , height , useTextlessMode , responsive =true , className , coverLetterClassName , 'aria-hidden': ariaHidden  })=>{
    const { t  } = useTranslation();
    const type = getTypeBasedOnSize(height);
    const deviationTitle = getDeviationTitle(deviation);
    const style = styleFromWidthHeight({
        width,
        height
    }, responsive);
    const isBigEnough = (style.height || 0) > typeSizeMap.ANTFART;
    return /*#__PURE__*/ React.createElement(Section, {
        className: classnames(s['root'], s[type], className),
        style: style,
        "aria-hidden": ariaHidden
    }, /*#__PURE__*/ React.createElement(LiteratureCoverLetter, {
        title: deviationTitle,
        isBigEnough: isBigEnough,
        className: coverLetterClassName
    }), !useTextlessMode && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: s['tag']
    }, t('deviationview.literature.tag')), /*#__PURE__*/ React.createElement(Heading, {
        className: s['title']
    }, deviationTitle), /*#__PURE__*/ React.createElement(ExcerptRenderer, {
        className: s['text-content'],
        textContent: deviation.textContent,
        htmlExcerptLegacy: true
    })));
};
LiteratureDumbView.displayName = 'LiteratureDumbView';
export default LiteratureDumbView;
